<template>
	<div class="masonry" :class="{ 'masonry-single': singleColumn }">
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		singleColumn: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.masonry {
	column-count: 1;
	column-gap: 2em;
}
@media (min-width: 1200px) {
	.masonry:not(.masonry-single) {
		column-count: 2;
	}
	.masonry-single {
		width: 50%;
	}
}
</style>
